import { type FC, useCallback } from 'react';

import { PikInNumbersV2 } from './PikInNumbersV2';
import { trackShowPikInNumbersSection } from './internal/tracking/trackShowPikInNumbersSection';

export const BLOCK_ID = 'pik-in-numbers-v2';

export const PikInNumbersV2Container: FC = () => {
  const handleView = useCallback(() => trackShowPikInNumbersSection(), []);

  return <PikInNumbersV2 id={BLOCK_ID} onView={handleView} />;
};
